/* eslint-disable object-curly-newline */
export const replacingValuesOnString = (cadena, objeto) => cadena.replace(/{{(.*?)}}/g, (match, p1) => objeto[p1.trim()] || match);
